<template>
    <div>
        <new-template></new-template>

        <div v-if="loading" class="card card-default">
            <div class="card-header">
                <span class="loading-text">Loading...</span>
                <span class="loader float-right"></span>
            </div>
        </div>
        <div v-else-if="error" class="card card-default">
            <div class="card-header">
                <div class="">
                    <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                    <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                    </div>
                </div>
            </div>
        </div>
        <div>
            <h3 v-if="templates.length > 0" class="nav-heading mt-4">Your templates</h3>
            <selection v-for="template in sortedTemplates" :role="role" :user="user" :key="template.id" :changeorder="template"></selection>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user'],

        created: function() {
            this.getTemplates();
            this.registerEvents();
        },

        mounted: function() {
        },

        data: function() {
            return {
                templateCreated: false,
                templates: [],
                total: 0,
                loading: true,
                error: false,
            };
        },

        watch: {

        },

        computed: {
            sortedTemplates: function() {
                return _.sortBy(this.templates, template => {
                    return template.title;
                });
            }
        },

        methods: {
            registerEvents: function() {
                var vm = this;
                Bus.$on('new-template-created', function (response) {
                    vm.newTemplateCreated(response);
                    return true;
                });
                Bus.$on('template-updated', function (response) {
                    vm.templateUpdated(response);
                    return true;
                });
                Bus.$on('template-deleted', function(response) {
                    vm.templateDeleted(response.id);
                    return true;
                });
            },

            newTemplateCreated: function(template) {
                this.templateCreated = true;
                this.templates.unshift(template);
            },

            templateDeleted: function(deletedTemplateId) {
                for (var index in this.templates) {
                    var template = this.templates[index];
                    if (template.id == deletedTemplateId) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.delete(this.templates, this.templates.indexOf(template));
                        break;
                    }
                }
            },

            templateUpdated: function(updatedTemplate) {
                for (var index in this.templates) {
                    var template = this.templates[index];
                    if (template.id == updatedTemplate.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.templates, this.templates.indexOf(template), updatedTemplate);
                        break;
                    }
                }
            },

            prettyDate: function (date) {
                return moment.utc(date).local().fromNow();
            },
           
            getTemplates: function() {                
                this.templates = [];
                axios.get(`/api/templates`)
                    .then(response => {
                        this.loading = false;
                        this.error = false;
                        this.templates = response.data.templates;
                        this.total = response.data.total;

                        Bus.$emit('template-count-updated', this.templates.length);
                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getTemplates();
            },
        }
    }
</script>
